<template>
  <div>
    <Customer
      :customer="customer"
      :loading="loading"
      :appointmentStartAt="appointmentStartAt"
      :ctaTextDefault="$t('global.actions.add_to_appointment')"
      :ctaTextCreate="$t('global.actions.add_to_appointment_and_create')"
      showAlertNotes
      @submit="save"
      @remove="onRemoveCustomer"
      v-test="'appointment-customer'"
    />
  </div>
</template>

<script
  setup
  lang="ts"
>
import { useI18n } from 'vue-i18n';
import Customer from '@/components/customer/index.vue';
import type { Customer as CustomerType } from '@/components/customer/types';
import { modal } from '@/helpers/ui';
import { updateAppointment } from '@/modules/calendar/actions/appointments';

const { t } = useI18n();

const props = defineProps<{
  appointmentId: number;
  appointmentStartAt?: string;
  customer?: CustomerType;
}>();

const emit = defineEmits(['updated']);

const loading = ref(false);

const onRemoveCustomer = () => {
  modal('confirmation', {
    message: t('appointment.customer_remove_confirmation'),
  }).then(() => {
    save(null);
  });
};

const save = (customer: CustomerType | null = null) => {
  loading.value = true;
  updateAppointment({
    input: {
      id: props.appointmentId,
      customerId: customer ? customer.id : null,
    },
  }).then((appointment) => {
    loading.value = false;
    emit('updated', appointment.customer);
  });
};
</script>
